module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Table of Contents")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#genesis"
    }
  }, [_vm._v("1. Genesis")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#the-era-of-mindlessness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Era of Mindlessness")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#state-of-the-world",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. State of the World")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#from-god-made-to-man-made-food",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From God-Made to Man-Made Food")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#from-healthcare-to-sick-care",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Healthcare to Sick Care")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#from-progression-to-regression",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Progression to Regression")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#the-end-of-an-era",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The End of an Era")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#the-river-we-live-upon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The River We Live Upon")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#ending-the-era-of-mindlessness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Ending the Era of Mindlessness")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#the-three-principles",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Three Principles")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#the-first-principle-accept-responsibility",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First Principle: Accept Responsibility")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#the-second-principle-acknowledge-impact",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Second Principle: Acknowledge Impact")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#the-third-principle-act-deliberately",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Third Principle: Act Deliberately")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#the-three-steps",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Three Steps")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#step-1-identifying-purpose",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 1: Identifying Purpose")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#step-2-apply-due-diligence",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 2: Apply Due Diligence")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#step-3-make-your-decision",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 3: Make Your Decision")])])])])])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#the-trodden-path",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Trodden Path")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#case-study-free-at-last",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Case Study: “Free at Last”")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#the-next-step",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Next Step")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0